// react-router NavigateOptions-equivalent. We use a plain object so callers
// can spread it into `navigate(dest.to, { replace: dest.replace })`.
const INTENT_KEY = "powtoon_auth_intent";
const INFLIGHT_KEY = "powtoon_auth_inflight";

type AuthIntent =
  | { kind: "learner"; projectId: string }
  | { kind: "learner-scorm"; projectId: string; version: "1.2" | "2004"; scenarioName?: string; orgDomain?: string }
  | { kind: "trainer" };

type PostLoginDestination = { to: string; replace: boolean };

export function setAuthIntent(intent: AuthIntent): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(INTENT_KEY, JSON.stringify(intent));
}

export function readAuthIntent(): AuthIntent | null {
  if (typeof window === "undefined") return null;
  const raw = window.sessionStorage.getItem(INTENT_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AuthIntent;
  } catch {
    return null;
  }
}

export function clearAuthIntent(): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(INTENT_KEY);
}

const INFLIGHT_TTL_MS = 60_000;

export function markAuthInflight(): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(INFLIGHT_KEY, String(Date.now()));
}

export function clearAuthInflight(): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(INFLIGHT_KEY);
}

export function isAuthInflight(): boolean {
  if (typeof window === "undefined") return false;
  const raw = window.sessionStorage.getItem(INFLIGHT_KEY);
  if (!raw) return false;
  const ts = Number(raw);
  if (!Number.isFinite(ts) || Date.now() - ts > INFLIGHT_TTL_MS) {
    window.sessionStorage.removeItem(INFLIGHT_KEY);
    return false;
  }
  return true;
}

export function consumePostLoginDestination(): PostLoginDestination {
  const intent = readAuthIntent();
  clearAuthIntent();
  clearAuthInflight();
  if (intent?.kind === "learner") {
    return { to: `/learn/${intent.projectId}`, replace: true };
  }
  if (intent?.kind === "learner-scorm") {
    const qs = new URLSearchParams({ scormVersion: intent.version });
    if (intent.orgDomain) qs.set("orgDomain", intent.orgDomain);
    if (intent.scenarioName) qs.set("scenarioName", intent.scenarioName);
    return { to: `/learn/${intent.projectId}/scorm?${qs.toString()}`, replace: true };
  }
  return { to: "/trainer", replace: true };
}
